<template>
  <el-container class="stui-content" style="display: block;">
    <el-row :span="2" style="margin-top: 30px;">


        <el-button type="primary" style="background-color: #409eff;" @click="reset()" round>重置级别</el-button>
    </el-row>
    <el-row  class="tui-el"  style="margin-top: 20px;">


      <el-col :span="18" style="border: 1px solid #c6c6c6;height: 850px;overflow-y:scroll;width: 60%;margin-top: 10px;">


        <el-row  class="tui-el" style="margin-bottom: 20px;">
          <el-col :span="6" style="text-align: center;">功能</el-col>
          <el-col :span="6" style="text-align: center;">lid</el-col>
          <el-col :span="6" style="text-align: center;">排序</el-col>


        </el-row>

        <el-row  class="tui-el" v-for="(item,index) in list" :key="index" >
          <el-col :span="6" style="text-align: center;line-height: 60px;">{{item.name}}</el-col>
          <el-col :span="6" style="text-align: center;line-height: 60px;">{{item.l_id}}</el-col>
          <el-col :span="6" style="text-align: center;line-height: 60px;" @click.native="change(item.orders,item.id)">{{item.orders}}</el-col>

        </el-row>
      </el-col>


    </el-row>

  <el-dialog
    title="修改级别"
    :visible.sync="centerDialogVisible"
    width="30%"
    center>
    <input type="text" class="searchT" v-model="addT"/>
    <span slot="footer" class="dialog-footer">
  	<el-button @click="centerDialogVisible = false">取 消</el-button>
  	<el-button type="primary" @click="doAdd()">确 定</el-button>
    </span>
  </el-dialog>
  </el-container>


</template>

<script>

  export default {
    data() {
       return {
        list: [],
        addT:'',
        id:0,
        centerDialogVisible:false,

      }
    },
	directives: {
    },
    created() {
      if(!window.localStorage.getItem('id')){
        this.$router.push({ path: '/' })
      }
      this.loadData()

    },

	methods:{

    change(name,id){
      this.addT = name
      this.id = id
      this.centerDialogVisible = true
    },


    loadData(){
      const axiosInstance = this.$axios.create({
      	headers: {'Content-Type': 'application/json;charset=utf-8'},// 设置传输内容的类型和编码
      	withCredentials: true,// 指定某个请求应该发送凭据。允许客户端携带跨域cookie，也需要此配置
      });
      axiosInstance({
      	method:'get',
      	params:{

      	},
      	url:'http://y31p.yoooooo.com/index.php/index/data/ardsList'
      })
      .then(res=>{
      	this.list = res.data;

      })
      .catch(err=>{

      });
    },
    doAdd(){

      const axiosInstance = this.$axios.create({
      	headers: {'Content-Type': 'application/json;charset=utf-8'},// 设置传输内容的类型和编码
      	withCredentials: true,// 指定某个请求应该发送凭据。允许客户端携带跨域cookie，也需要此配置
      });


      axiosInstance({
      	method:'post',
      	params:{
      		id:this.id,
          name:this.addT,
      	},
      	url:'http://y31p.yoooooo.com/index.php/index/data/ardsChange'
      })
      .then(res=>{
      	if(res.data.code == 200){
           this.centerDialogVisible = false
           this.$message({
           	type: 'success',
           	message: '操作成功'
           });
            this.loadData()
      	}else{

      	}

      })
      .catch(err=>{

      });
    },

    reset(id,index){

      const axiosInstance = this.$axios.create({
      	headers: {'Content-Type': 'application/json;charset=utf-8'},// 设置传输内容的类型和编码
      	withCredentials: true,// 指定某个请求应该发送凭据。允许客户端携带跨域cookie，也需要此配置
      });


      axiosInstance({
      	method:'post',
      	params:{

      	},
      	url:'http://y31p.yoooooo.com/index.php/index/data/ardsreset'
      })
      .then(res=>{
      	if(res.data.code == 200){

           this.$message({
           	type: 'success',
           	message: '操作成功'
           });
            
      	}else{

      	}

      })
      .catch(err=>{

      });
    },

    msg(msg,type){
    	this.$message({
    	  message: msg,
    	  type: type
    	});
    },

	}


  }
</script>

<style>
  .searchT{
  	width: 80%;
  	margin-left: 10%;
  	height: 30px;
  }
  .stui-content{
    margin-left: 10%;
    margin-top: 100px;
  	width: 100%;
  	height: 100%;
  }


</style>



// WEBPACK FOOTER //
// src/components/main/ards.vue